import React from 'react';
import AddOrEditBrokerForm from './AddOrEditBrokerForm';

/* React functional component */
const CreateBrokerScreen = () => {
  return <AddOrEditBrokerForm mode="add" />;
};

export default CreateBrokerScreen;
